import React from 'react';
import { Box, Stack } from '@mui/material';

import { OrderDistributionChart } from './camp-statistics/OrderDistributionChart';
import { GenderDistributionChart } from './camp-statistics/GenderDistributionChart';

export const CampStatistics = props => {
  const { data } = props;

  return (
    <Stack direction="column">
      <Stack direction="row">
        <Box flex="1 1 40%">
          <GenderDistributionChart data={data.gender_distribution} />
        </Box>
        <Box flex="1 1 60%">
          <OrderDistributionChart data={data.orders} />
        </Box>
      </Stack>
    </Stack>
  );
};
